import { z } from "zod";

export const searchReq = {
    params: z.object({
        type: z.enum(["all", "post", "people", "gallery"]),
        searchTerm: z.string(),
    }),
};
